import { getApiUrl } from './common';

/** *
 * this is mutable object so changing it effects all fetches for this method, handle with care!
 */
export function setMethodMutableOverride(methodConfig, override) {
  const prevValue = methodConfig._mutableOverride;
  methodConfig._mutableOverride = override;
  return prevValue;
}
export function getMethodMutableOverride(methodConfig) {
  return methodConfig._mutableOverride;
}

/**
 * this is mutable object so changing it effects all queryFn for this method, mostly designed for intercepting queryFn calls
 * handle with care
 */

const MutableMethodsFetchMiddleware = {};
export function setMutableMethodMiddleware(methodConfig, middleware) {
  var _middleware;
  if (middleware === void 0) {
    middleware = null;
  }
  const key = getApiUrl(methodConfig);
  MutableMethodsFetchMiddleware[key] = (_middleware = middleware) != null ? _middleware : undefined;
}
export function removeMutableMethodMiddleware(methodConfig) {
  setMutableMethodMiddleware(methodConfig, undefined);
}
export function getMutableMethodMiddleware(methodConfig) {
  var _MutableMethodsFetchM;
  const key = getApiUrl(methodConfig);
  return (_MutableMethodsFetchM = MutableMethodsFetchMiddleware[key]) != null ? _MutableMethodsFetchM : undefined;
}
//# sourceMappingURL=internal.js.map